/* import __COLOCATED_TEMPLATE__ from './successor-inserter.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { action } from '@ember/object';

import Component from '@glimmer/component';
import type Graph from '../../../models/graph-editor/graph';
import type Node from '../../../models/graph-editor/node';
import Coordinates from '../../../models/graph-editor/coordinates';
import { type ConnectionPointInputs } from '../../../models/graph-editor/connection-point';

interface Args {
  predecessor: Node;
  connectionPoints?: Array<ConnectionPointInputs>;
  nodeDataObject?: any;
  edgeDataObject?: any;
  onInsert?(node: Node): void;
}

export default class GraphEditorNodeSuccessorInserterComponent extends Component<Args> {
  get graph(): Graph {
    return this.args.predecessor.graph;
  }

  @action insertSuccessor() {
    this.graph.trackActions(() => {
      let defaultSpacing = this.graph.settings.node.defaultSpacing;
      let position = {
        x: Coordinates.roundedCoordinate(
          this.args.predecessor.bounds.right + defaultSpacing,
          this.graph.settings.grid.spacing,
        ),
        y: Coordinates.roundedCoordinate(
          this.args.predecessor.bounds.top,
          this.graph.settings.grid.spacing,
        ),
      };
      if (this.graph.hooks.canInsertNode(this.args.nodeDataObject)) {
        let successor = this.graph.addNode({
          position,
          dataObject: this.args.nodeDataObject,
          connectionPoints: this.args.connectionPoints,
        });
        this.graph.hooks.didInsertNode(successor);
        if (this.graph.hooks.canInsertEdge(this.args.predecessor, successor)) {
          let edge = this.graph.addEdge({
            predecessor: this.args.predecessor,
            successor,
            dataObject: this.args.edgeDataObject,
          });
          this.graph.hooks.didInsertEdge(edge);

          if (this.args.onInsert) {
            this.args.onInsert(successor);
          }
        }
      }
    });
  }
}
